import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {DobryAgentBlogCategory} from '../../../../shared/interface/dobry-agent-blog-article';
import {DobryAgentBlogCategoryService} from '../../../../shared/services/dobry-agent-blog-category.service';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';

@Component({
  selector: 'app-da-category-details',
  templateUrl: './da-category-details.component.html',
  styleUrls: ['./da-category-details.component.scss']
})
export class DaCategoryDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  categoryId?: string;
  loading = false;
  modify = false;

  userPermissions: ReplaySubject<UserPermissions>;
  blogCategoryObject?: DobryAgentBlogCategory;
  blogCategory: ReplaySubject<DobryAgentBlogCategory> = new ReplaySubject<DobryAgentBlogCategory>(1);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private blogCategoryService: DobryAgentBlogCategoryService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.categoryId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  load(): void {
    if (!this.categoryId) {
      this.router.navigate(['/blog-dobry-agent/kategorie']);
      return;
    }

    this.loading = true;

    this.blogCategoryService.get(this.categoryId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (category: DobryAgentBlogCategory) => {
          this.blogCategory.next(category);
          this.blogCategoryObject = category;
          this.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;

          this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
            duration: 2000
          });

          this.router.navigate(['/blog-dobry-agent/kategorie']);
        }
      });
  }
}
